"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConstantMap = exports.typeCheckedFreeze = void 0;
/** @internal @todo in TS v4.9+ declare `as const satisfies Readonly<Record<Key, Value>>>` and remove this util */
const typeCheckedFreeze = () => (object) => Object.freeze(object);
exports.typeCheckedFreeze = typeCheckedFreeze;
/**
 * @internal
 * Use this when the map's keys and values are constant. As such, getting a key
 * that is not present in the map should throw an error, which this does
 * both at compile time/statically via TS and at runtime via JS.
 */
class ConstantMap {
    constructor(object) {
        this.map = new Map(Object.entries(object));
    }
    get(key) {
        if (!this.map.has(key))
            throw new Error(`key "${String(key)}" not in map`);
        return this.map.get(key);
    }
}
exports.ConstantMap = ConstantMap;
//# sourceMappingURL=utils.js.map